import ServiceCRUD from '../../../../../services/ServiceGasOrder';

class StockService extends ServiceCRUD {
  constructor() {
    super(`/api/estoques`);
  }
}

export default new StockService();
